import { useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { slides, padding, colorbg, title, url, positiontitle } = attributes;
  const blockProps = useBlockProps.save({
    className: `portfolio ${colorbg ? 'sectiongray' : ''} ${padding}`,
  });
  const Tag = title ? 'section' : 'div';

  return (
    <>
      {slides && (
        <Tag {...blockProps}>
          <div class="container-fluid p-0">
            {title && (
              <div class="row">
                <div className={`globaltitle ${positiontitle}`}>
                  <h2>{title}</h2>
                </div>
              </div>
            )}
            <div class="row">
              <div class="col">
                <div class="portfolio__mansory wp-block-gallery">
                  {slides.map((slide, index) => (
                    <div class="portfolio__mansory-item">
                      <a href={slide.url}>
                        <img
                          loading="lazy"
                          src={slide.url}
                          alt={slide.alt}
                          height={slide.sizes.full.height}
                          width={slide.sizes.full.width}
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {url && (
              <div class="row justify-content-center pt-5">
                <div class="col-auto">
                  <a href={url} class="btn btn-border btn-url">
                    Смотреть портфолио
                  </a>
                </div>
              </div>
            )}
          </div>
        </Tag>
      )}
    </>
  );
}
